import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { createAssessmentAPIEndpoint, EndPoints } from '../../../services/AssessmentServices';
import ExamCard from "./components/ExamCard";
import { Link } from "react-router-dom";

function ExamsList() {
  const [exams, setexams] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    createAssessmentAPIEndpoint(EndPoints.availableAssessments)
      .fetchWithParams({ type: 0 })
      .then((res) => {
        console.log("exams fetched successfully:", res.data);
        setexams(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching exams:", error);
        setLoading(false);
      });
  }, []);
  return (
    <>
      <section className="section exams" translate="no">
        <div className="container">
          {loading ? (
            <div className="loading">Loading Exams...</div>
          ) : exams.length === 0 ? (
            <div className="no-exams">No Exams available at the moment.</div>
          ) : (
            <Box className="exam-grid">
              {exams.map((exam) => (
                <ExamCard key={exam.id} exam={exam} />
              ))}
            </Box>
          )}
        </div>
      </section>
    </>
  );
}

export default ExamsList;
